import { render, staticRenderFns } from "./importNode.vue?vue&type=template&id=72e21426&scoped=true&"
import script from "./importNode.vue?vue&type=script&lang=js&"
export * from "./importNode.vue?vue&type=script&lang=js&"
import style0 from "./importNode.vue?vue&type=style&index=0&id=72e21426&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e21426",
  null
  
)

export default component.exports